export function formatNumberToLocale(locale: string, number: number): string {
  return new Intl.NumberFormat(locale).format(number)
}
